import React, { useEffect } from "react";
import CoursesSection from "../Common/CoursesSection";
import StatsCounter from "../Common/StatsCounter";
import { coursesData } from "../../data/coursesData";
import { statsData } from "../../data/statsData";

function Courses() {
  
      useEffect(() => {
        window.scrollTo(0, 0);
      }, {});

  return (

<div classNameName="service">

<div className="container-fluid page-header py-5">
            <div className="container text-center py-5">
                <h1 className="display-2 text-white mb-4 animated slideInDown">Courses</h1>
                <nav aria-label="breadcrumb animated slideInDown">
                    <ol className="breadcrumb justify-content-center mb-0">
                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                        <li className="breadcrumb-item"><a href="#">Pages</a></li>
                        <li className="breadcrumb-item" aria-current="page">Courses</li>
                    </ol>
                </nav>
            </div>
        </div>

        <StatsCounter stats={statsData} />

       <CoursesSection courses={coursesData} />
</div>
 );
}

export default Courses;  
